import Component from '../component/component';
import Helpers from '../helpers/helpers';

import './header.scss';

interface IHeaderSettings {
    scrollClass?: string;
    navToggleClass?: string;
    navToggleActiveClass?: string;
    navToggleLabelClass?: string;
    openClass?: string;
    hiddenSubmenuClass?: string;
}

export default class Header extends Component {
    static initSelector: string = '.header';

    public static fadeInClass: string = 'fade-in';

    container: JQuery;
    canvas: JQuery;
    navToggle: JQuery;
    navToggleLabel: JQuery;
    settings: IHeaderSettings;
    isOpen: boolean;
    isFakeOpen: boolean;

    constructor(target: HTMLElement) {
        super(target);

        this.settings = {
            hiddenSubmenuClass: 'has-hidden-submenu',
            navToggleActiveClass: 'is-active',
            navToggleClass: 'header__nav-toggle',
            navToggleLabelClass: 'nav-toggle__label',
            openClass: 'has-open-navigation',
            scrollClass: 'has-scrolled',
        };

        this.container = $('body');
        this.canvas = $('.main');
        this.navToggle = this.element.find('.' + this.settings.navToggleClass);
        this.navToggleLabel = this.navToggle.find('.' + this.settings.navToggleLabelClass);
        this.isOpen = false;
        this.isFakeOpen = false;

        this.init();
    }

    init(): void {
        this.scroll();

        $(window).on('scroll', this.scroll.bind(this));
        this.navToggle.on('click', this.toggle.bind(this));
    }

    scroll(): void {
        if (!this.isOpen) {
            if ($(window).scrollTop() > 1) {
                this.element.addClass(this.settings.scrollClass);
            } else {
                this.element.removeClass(this.settings.scrollClass);
            }
        }

        if (($(window).scrollTop()) < $('body').innerHeight() - 50) {
            this.close(true);
        } else {
            this.open(true);
        }
    }

    toggle(): void {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    open(isFake: boolean = false): void {
        if (!this.isOpen) {
            this.isOpen = true;

            if (!isFake) {
                const scrollTop: number = $(document).scrollTop();
                const mainHeight: number = this.canvas.innerHeight();
                const mainMaxHeight: number = Math.min(($(window).innerHeight() + scrollTop), mainHeight);

                Helpers.disableScroll();
                this.container.addClass(this.settings.openClass);

                this.canvas.css({
                    height: mainMaxHeight,
                    overflow: 'hidden',
                });
            } else {
                this.element.addClass(this.settings.hiddenSubmenuClass);
                this.isFakeOpen = true;
            }

            this.setNavToggleState(true);
        }
    }

    close(isFake: boolean = false): void {
        if (this.isOpen) {
            this.setNavToggleState(false);

            if (!isFake) {
                if (this.isFakeOpen) {
                    Helpers.scrollToNumber(this.canvas.height() - $(window).height());
                    this.isFakeOpen = false;
                } else {
                    this.container.removeClass(this.settings.openClass);

                    // enable scroll after slide transition ends
                    setTimeout(() => {
                        Helpers.enableScroll();
                        this.canvas.css({
                            height: '',
                            overflow: '',
                        });
                    }, 800);
                }
            } else {
                this.element.removeClass(this.settings.hiddenSubmenuClass);
                this.isFakeOpen = false;
            }

            this.isOpen = false;
        }
    }

    setNavToggleText(newText: string): void {
        if (this.navToggleLabel.is(':visible')) {
            this.navToggleLabel.fadeOut(400, $.proxy(function(){
                this.navToggleLabel.text(newText);
                this.navToggleLabel.fadeIn(400);
            }, this));
        } else {
            this.navToggleLabel.text(newText);
        }
    }

    setNavToggleState(activate: boolean): void {
        if (activate) {
            this.navToggle.addClass(this.settings.navToggleActiveClass);
            this.setNavToggleText(this.navToggle.data('activeLabel'));
        } else {
            this.navToggle.removeClass(this.settings.navToggleActiveClass);
            this.setNavToggleText(this.navToggle.data('defaultLabel'));
        }
    }
}
